export enum Instrument {
  AcousticGuitar,
  AcousticEffects,
  AcousticPercussion,
  Bass,
  Digitone,
  Drums,
  ElGuitar,
  ElGuitarBow,
  ElGuitarPerc,
  Glasses,
  Harmonica,
  Harmonium,
  Mandolin,
  Metronome,
  Noise,
  Kalimba,
  Organ,
  Piano,
  Rhodes,
  Stomp,
  Synth,
  Tambourine,
}

export enum Mode {
  Byzantine,
  Dissonant,
  HarmonicMinor,
  Major,
  MinorMajor,
  PentatonicMajor,
  PentatonicMinor,
  Phrygian,
  Octatonic,
  Undefined,
}

export enum VocalStyle {
  Speak,
  Sing,
  Instrumental,
  Multi,
  Effects,
  Reverse,
  Growl,
  Whisper,
}

export interface Clip {
  accessRecordId?: string;
  accessRecordStatus?: string;
  density: number;
  duration: number; // seconds
  el?: HTMLAudioElement;
  filename: string;
  gdrive: string;
  group: string;
  id: number;
  intensity: number;
  instrumentation: Instrument[];
  lyrics?: string;
  order: number;
  poolName: "CMPS" | "PNCL" | "MOTH" | "VRTX",
  rootMode: Mode;
  rootTone?: string | null;
  trackName: string;
  trackNameDisplay?: string;
  trackNameVersion: string;
  trackVersion: string;
  vocal: VocalStyle;
}

export interface ClipInsurmountable extends Clip {
  section: "intro" | "mid" | "end";
  variant: "full" | "half";
}

export interface Quote {
  headline: string;
  subheadline: string;
  content: string;
}

export interface Poem {
  title: string;
  content: string;
}

export interface Section {
  title: string;
  content: Poem[];
}

export interface Chapter {
  title: {
    hex: string;
    plain: string;
  };
  sections: string[][];
}
